/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Issue_Duplicate_FileInputs */

const en_inbound_issue_duplicate_file = /** @type {(inputs: Inbound_Issue_Duplicate_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the file is already linked`)
};

/**
* | output |
* | --- |
* | "the file is already linked" |
*
* @param {Inbound_Issue_Duplicate_FileInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_issue_duplicate_file = /** @type {((inputs?: Inbound_Issue_Duplicate_FileInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Issue_Duplicate_FileInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_issue_duplicate_file(inputs)
});